import { get, api } from './client.js';

/**
 * Customer leads API（tenant-scoped；後端用 X-User-Uid 解析子帳號可見範圍）
 *
 *   GET    /api/ivr/leads/scenarios?hostId=                       跨 avatar 列收單情境（依 scope）
 *   GET    /api/ivr/leads/list?hostId=&avatarId=&scenarioId=      名單
 *   DELETE /api/ivr/leads/:id?hostId=&avatarId=&scenarioId=       刪一筆
 */

export async function listLeadScenarios(hostId) {
    const params = new URLSearchParams({ hostId });
    return get(`/api/ivr/leads/scenarios?${params.toString()}`);
}

export async function listLeads({ hostId, scenarioId, avatarId, limit = 200, from, to }) {
    const params = new URLSearchParams({ hostId, scenarioId, avatarId, limit: String(limit) });
    if (from) params.set('from', from);   // YYYY-MM-DD，依收單時間（台灣日界）
    if (to) params.set('to', to);
    return get(`/api/ivr/leads/list?${params.toString()}`);
}

/** 刪除一筆 lead — 需要 hostId + avatarId + scenarioId（後端驗 scope + 重用 composite index） */
export async function deleteLead(id, { hostId, scenarioId, avatarId }) {
    const params = new URLSearchParams({ hostId, scenarioId, avatarId });
    return api('DELETE', `/api/ivr/leads/${encodeURIComponent(id)}?${params.toString()}`);
}
